import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  font-size: 14px;
  position: relative;
  float: right;
  margin-top: -30px;
`;

interface Props {
  children: any;
}

export const DivInRight = (props: Props) => {
  const { children } = props;
  return <StyledDiv>{children}</StyledDiv>;
};
